module.exports = __webpack_public_path__ + "img/product_pressalit_wash01.ba9ae173.jpg";